import { RootState } from 'data/store';
import { NewChatState } from 'data/types';
import { createSelector } from 'reselect';

// Base selector to get the matrix state from RootState
const newChatSelector = (state: RootState) => state.newChat;

/**
 * Helper function to create memoized selectors for different fields
 * @param field - The specific field of the Matrix state to select
 * @returns A memoized selector for the specified field
 */
const createNewChatSelector = <T extends keyof NewChatState>(field: T) =>
  createSelector(
    [newChatSelector], // Ensure newChatSelector returns NewChatState
    (newChatState: NewChatState) => newChatState[field]
  );

// Memoized selectors for various fields in the NewChatState

export const selectNewChatClient = createNewChatSelector('client');
export const selectNewChatLoading = createNewChatSelector('loading');
export const selectNewChatPublicRooms = createNewChatSelector('publicRooms');
export const selectNewChatDmRooms = createNewChatSelector('dmRooms');
export const selectNewChatSelectedRoom = createNewChatSelector('selectedRoom');
export const selectNewChatSearchQuery = createNewChatSelector('searchQuery');
export const selectNewChatSearchResults = createNewChatSelector('searchResults');
export const selectNewChatInvitations = createNewChatSelector('invitations');
export const selectNewChatMessages = createNewChatSelector('messages');
export const selectNewChatAlert = createNewChatSelector('alert');
